<section>
  <ion-header class="ion-no-border">
    <ion-toolbar>
      <ion-buttons slot="end">
        <ion-button (click)="dismiss()">
          <ion-icon name="close-circle-outline"></ion-icon>
        </ion-button>
      </ion-buttons>
      <ion-title>Importante</ion-title>
    </ion-toolbar>
  </ion-header>
  <hr>
</section>

<article>
  <ion-text>Os dados disponibilizados pelo Ministério do Meio Ambiente – MMA, <br/> 
    por meio do aplicativo MonitorAr, são de responsabilidade da fonte responsável.<br/> 
    Ressalta-se que todos os dados apresentados estão sujeitos à validação posterior.</ion-text>
  <!-- <ion-text class="bold">Fonte: {{ estacao?.noFonteDados }}</ion-text> -->
</article>